import Sparkline from "@/components/dashboard/Sparkline";

export default function KpiCard({ label, value, sub, accent = false, sparkline, sparkColor, testId }) {
  return (
    <div
      data-testid={testId}
      className={`rounded-sm border ${accent ? "bg-navy-900 text-ivory-50 border-navy-900" : "bg-white text-navy-900 border-border"} p-5 flex flex-col`}
    >
      <p className={`editorial-overline ${accent ? "!text-gold-400" : ""}`}>{label}</p>
      <p className="font-serif text-3xl mt-2 leading-none">{value}</p>
      {sub && <p className={`text-xs mt-2 ${accent ? "text-ivory-200/70" : "text-muted-foreground"}`}>{sub}</p>}
      {sparkline && sparkline.length > 0 && (
        <div className="mt-3 -mx-1">
          <Sparkline
            data={sparkline}
            color={sparkColor || (accent ? "#C5A059" : "#0A1128")}
            height={32}
            testId={testId ? `sparkline-${testId}` : undefined}
          />
        </div>
      )}
    </div>
  );
}
